<template>
    <div v-if="item.startObj && timezone" 
        class="calendar-item-time">
        {{asTimeOnly(item.startObj, timezone)}}
        <span> - </span>
        {{asTimeOnly(item.endObj, timezone)}}
    </div>
</template>
<script>
import {asTimeOnly} from '@/components/DateTime';

export default {
    name: 'CalendarItemTime',
    props: {
        item: {
            type: Object,
            required: true,
        },
        timezone: { // If no timezone is passed, don't show the time field
            type: String,
            required: false,
        },
    },
    methods: {
        asTimeOnly,
    },
}
</script>
<style>

</style>